export function inGroupsOf<T>(array: T[], number: number): (T)[][] {
  let index = -number
  let slices = []

  while ((index += number) < array.length) {
    var s = array.slice(index, index + number)
    slices.push(s)
  }

  return slices
}